import React from 'react';
import { DataTableV3GlobalFilterProps } from '../types';
import { useTranslation } from 'react-i18next';
import { Search } from '@innovationnorway/cl-react';

const DataTableGlobalFilter: React.FC<DataTableV3GlobalFilterProps> = ({
  texts,
  value,
  onChange,
  disabled,
}) => {
  const { t: tCommon } = useTranslation();

  if (disabled) {
    return <div className="flex--1" />;
  }

  return (
    <Search
      className="flex--1 margin-bottom--2"
      aria-label={texts?.globalFilterPlaceholder ?? tCommon('search') + '...'}
    >
      <Search.Input
        className="box-sizing--border-box"
        placeholder={texts?.globalFilterPlaceholder ?? tCommon('search') + '...'}
        onChange={onChange}
        value={value}
      ></Search.Input>
      <Search.Clear></Search.Clear>
    </Search>
  );
};

export default DataTableGlobalFilter;
